/* Rugged Unleashed — video.
   Autoplay without paying for it on page load: the <video> is not created until
   the section is near the viewport, so an 11MB file costs nothing above the fold.
   Muted + playsinline are required for autoplay to be permitted on iOS/Android. */
/* Every ru-video section includes this file, so a page with two videos runs it
   twice. A top-level class declaration would throw "already declared" the second
   time; the guard keeps the class inside a block that only runs once. */
if (!customElements.get('ru-video')) {
class RuVideo extends HTMLElement {
  connectedCallback() {
    this.frame = this.querySelector('[data-ruv-frame]');
    this.tpl = this.querySelector('template');
    if (!this.frame || !this.tpl) return;

    const btn = this.querySelector('[data-ruv-play]');
    if (btn) btn.addEventListener('click', () => this.load(true));
    this.warm();

    if (this.dataset.autoplay !== 'true') return;

    if (!('IntersectionObserver' in window)) { this.load(false); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        this.load(false);
      });
    }, { rootMargin: '250px 0px' });   // start fetching just before it is reached
    io.observe(this);
  }

  load(fromClick) {
    if (this.frame.dataset.ruvLoaded === 'true') return;
    this.frame.dataset.ruvLoaded = 'true';
    const frag = this.tpl.content.cloneNode(true);
    this.frame.querySelectorAll('img, [data-ruv-play]').forEach((n) => n.remove());
    this.frame.appendChild(frag);
    const v = this.frame.querySelector('video');
    if (!v) return;
    // Start on the <=720px HLS variant picked in warm(), not the master playlist
    // (iOS starts on its first-listed variant, which Shopify makes 1080p).
    const hls = v.querySelector('source[type="application/x-mpegURL"]');
    if (hls && this.variant) { hls.src = this.variant; v.load(); }
    if (fromClick) v.muted = false;
    /* If the browser blocks autoplay, fall back to a paused video with controls
       rather than leaving a dead black rectangle. */
    const p = v.play();
    if (p && p.catch) p.catch(() => { v.controls = true; });
  }
}
RuVideo.prototype.warm = function () {
  const src = this.tpl && this.tpl.content.querySelector('source[type="application/x-mpegURL"]');
  if (!src || !('IntersectionObserver' in window) || !window.fetch) return;
  const c = navigator.connection || {};
  const cap = (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || '')) ? 480 : 720;
  const io = new IntersectionObserver((entries) => {
    if (!entries.some((e) => e.isIntersecting)) return;
    io.disconnect();
    const master = new URL(src.getAttribute('src'), location.href).href;
    fetch(master).then((r) => r.text()).then((text) => {
      const lines = text.split(/\r?\n/);
      let best = null;
      lines.forEach((l, i) => {
        if (!l.startsWith('#EXT-X-STREAM-INF')) return;
        const r = /RESOLUTION=(\d+)x(\d+)/.exec(l);
        const uri = (lines[i + 1] || '').trim();
        if (!r || !uri) return;
        const h = +r[2];
        if (h <= cap && (!best || h > best.h)) best = { h, url: new URL(uri, master).href };
      });
      if (best) { this.variant = best.url; fetch(best.url).catch(() => {}); }
    }).catch(() => {});
  }, { rootMargin: '600px 0px' });
  io.observe(this);
};
customElements.define('ru-video', RuVideo);
}
